// Định nghĩa các template có sẵn
import Default from './Default'
import DoubleDish from './DoubleDish'
import SingleDish from './SingleDish'
import VideoMenuDish from './VideoDish'

export const MenuTemplateMap = {
  default: Default,
  single_dish: SingleDish,
  double_dish: DoubleDish,
  video_dish: VideoMenuDish,
}
